<template>
  <div v-if="apiUser" class="profile-page">
    <div class="layout__content__header">
      <app-back
        :route="{
          name: 'dashboard',
          params: {
            customerId: selectedCustomer.customerId,
            projectId: selectedProject.projectId
          }
        }"
        :text="'naDashboard'"
      />
      <h1 class="">{{ apiUser.firstName }} {{ apiUser.lastName }}</h1>
    </div>
    <div class="layout__content__content">
      <div class="mb-5 row">
        <div class="mb-sm-3 mb-md-2 mb-lg-3 col-lg-6">
          <div class="layout__box">
            <div class="layout__box__header justify-content-between">
              <div class="d-flex align-items-center">
                <div class="atom-icon mr-2">
                  <img class="navbar__menu__icon" src="@/assets/icons/menu/ico-ico-menu-user-gray.svg" />
                </div>
                <h2 class="mb-0">
                  {{ $t("osobniUdaje") }}
                </h2>
              </div>
            </div>
            <div class="layout__box__content">
              <div class="pt-3 pb-4">
                <p class="font-weight-bolder mb-0">
                  {{ $t("jmeno") }}
                </p>
                <p class="text-larger font-weight-light gray-text mb-3">
                  {{ apiUser.firstName }} {{ apiUser.lastName }}
                </p>
                <p class="font-weight-bolder mb-0">
                  {{ $t("email") }}
                </p>
                <p class="text-larger font-weight-light gray-text mb-3">
                  {{ apiUser.email }}
                </p>
                <p class="font-weight-bolder mb-0">
                  {{ $t("telefon") }}
                </p>
                <p v-if="apiUser" class="text-larger font-weight-light gray-text mb-4">
                  <span v-if="apiUser" />
                  {{ $filters.phone(apiUser.phone, "CZ") }}
                </p>
                <!--div class="d-flex align-items-center mb-2">
                  <div class="atom-icon atom-icon--small">
                    <img
                      src="@/assets/icons/ico-ico-ticket.svg"
                      class="navbar__menu__icon"
                    />
                  </div>
                  <a :href="urlChangeInfo">{{ $t("podatTicketNaZmenuOsobnichUdaju") }}</a>
                </div-->
                <div class="d-flex align-items-center">
                  <div class="atom-icon atom-icon--small">
                    <img class="navbar__menu__icon" src="@/assets/icons/ico-ico-heslo.svg" />
                  </div>
                  <a :href="pwdLink" target="_blank">{{ $t("zmenitHeslo") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-sm-3 mb-md-2 mb-lg-3 col-lg-6">
          <div class="layout__box">
            <div class="layout__box__header justify-content-between">
              <div class="d-flex align-items-center">
                <div class="atom-icon mr-2">
                  <img class="navbar__menu__icon" src="@/assets/icons/menu/ico-ico-menu-nastaveni-gray.svg" />
                </div>
                <h2 class="mb-0">
                  {{ $t("nasatevniNapovedyANotifikaci") }}
                </h2>
              </div>
            </div>
            <div class="layout__box__content">
              <div class="pt-3 pb-4">
                <p class="text-large font-weight-bolder mb-1">
                  {{ $t("napovedaPanaRadio") }}
                </p>
                <p class="font-weight-light mb-3">
                  {{ $t("napovedyPanaRadioText") }}
                </p>
                <Switcher :key="23" :text="true" :value="!radioDisabled" @switch="switchRadio" />
              </div>
              <div class="pt-3 pb-4">
                <p class="text-large font-weight-bolder mb-1">
                  {{ $t("nadpisUvitaciTutorial") }}
                </p>
                <p class="font-weight-light mb-3">
                  {{ $t("textUvitaciTutorial") }}
                </p>
                <div class="d-flex">
                  <Switcher
                    :key="23"
                    :field-id="'tutorial'"
                    :text="true"
                    :value="tutorialVisible"
                    @switch="switchTutorial"
                  />
                  <span
                    class="d-flex col-12 col-sm-2 align-items-center link"
                    @click="
                      () => {
                        switchTutorial()
                        if (!tutorialVisible) {
                          switchTutorial()
                        }
                        $router.push({
                          name: 'dashboard',
                          params: { customerId: selectedCustomer.customerId, projectId: selectedProject.projectId }
                        })
                      }
                    "
                  >
                    {{ $t("START") }}
                  </span>
                </div>
              </div>
              <div v-if="apiUser" class="pt-3 pb-4">
                <p class="text-large font-weight-bolder mb-1">
                  {{ $t("nadpisAdminTutorial") }}
                </p>
                <p class="font-weight-light mb-3">
                  {{ $t("textAdminTutorial") }}
                </p>
                <div class="d-flex">
                  <Switcher
                    :key="23"
                    :field-id="'tutorialAdmin'"
                    :text="true"
                    :value="tutorialVisibleAdmin"
                    @switch="switchTutorialAdmin"
                  />
                  <span
                    class="d-flex col-12 col-sm-2 align-items-center link"
                    @click="
                      () => {
                        switchTutorialAdmin()
                        if (!tutorialVisibleAdmin) {
                          switchTutorialAdmin()
                        }
                        $router.push({
                          name: 'adminMenu',
                          params: {
                            customerId: selectedCustomer.customerId,
                            projectId: selectedProject.projectId
                          }
                        })
                      }
                    "
                  >
                    {{ $t("START") }}
                  </span>
                </div>
              </div>
              <p class="text-large font-weight-bolder mb-1 mt-5">
                {{ $t("denniReportyDoEmailu") }}
              </p>
              <p class="font-weight-light mb-3">
                {{ $t("denniReportyDoEmailuText") }}
              </p>
              <app-loader v-if="!loaded" class="mb-3" />
              <div v-if="notifications.length > 0">
                <div class="mt-2 mb-4">
                  <div
                    v-for="notification in notifications"
                    :key="notification.notificationId"
                    class="border-bottom-gray border-bottom-gray__nolast"
                  >
                    <div class="row px-4 py-3 align-items-center justify-content-between">
                      <span class="col-12 col-md-5 col-lg-12 col-xl-5">
                        {{ notification.customer.customerName }}
                      </span>
                      <span class="col-12 col-md-7 col-lg-12 col-xl-7 row">
                        <notifications-register
                          :item="notification"
                          class="col-12 col-sm-10"
                          @switch="loadNotifications"
                        />
                        <span
                          class="d-flex col-12 col-sm-2 align-items-center link"
                          @click="
                            () => {
                              actionItem = notification
                              toggleEditNotificationsModal('editNotifications')
                            }
                          "
                        >
                          {{ $t("upravit") }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <error-modal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>

    <edit-notifications-modal
      v-if="this.actionItem"
      :from-profile="true"
      :item="this.actionItem"
      :opened="openedEditNotificationsModal"
      @closeBox="toggleEditNotificationsModal"
      @openBox="toggleEditNotificationsModal"
    />
  </div>
</template>

<script>
import axios from "axios"
import Back from "@/components/back.vue"
import Switcher from "@/components/switcher"
import EditNotificationsModal from "@/components/modals/notifications/edit.vue"
import NotificationsRegister from "@/components/notifications/register.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Loader from "@/components/loader.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    "app-back": Back,
    Switcher,
    "edit-notifications-modal": EditNotificationsModal,
    "notifications-register": NotificationsRegister,
    "error-modal": ErrorModal,
    "app-loader": Loader
  },
  setup() {
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()

    return { authStore, configStore, customerStore, projectStore }
  },
  data() {
    return {
      users: [],
      loaded: false,
      actionItem: {},
      openedEditNotificationsModal: [],
      notifications: [],
      errorsToTranslate: [],
      openedError: false,
      selectedProject: JSON.parse(localStorage.getItem("selectedProject")),
      selectedCustomer: JSON.parse(localStorage.getItem("selectedCustomer"))
    }
  },
  computed: {
    user() {
      return this.authStore.user
    },
    apiUser() {
      return this.authStore.apiUser
    },
    urlChangePwd() {
      return this.$t("URLzmenitHeslo")
    },
    urlChangeInfo() {
      return this.$t("URLzmenitInfo")
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    tutorialVisible() {
      return this.configStore.shouldShowTutorial
    },
    tutorialVisibleAdmin() {
      return this.configStore.shouldShowTutorialAdmin
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    },
    pwdLink() {
      return process.env.VUE_APP_AUTHORITY + "account/password?kc_locale=" + (this.$i18n.locale == "cz" ? "cs" : "en")
    },
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    apiUser() {
      this.loadNotifications()
    },
    customer() {
      this.loadNotifications()
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    async loadNotifications() {
      let apiUser = await this.apiUser
      let notifications = []
      this.errorsToTranslate = []
      if (apiUser) {
        console.log("user", this.apiUser)

        axios
          .get(process.env.VUE_APP_API + "/notifications?email[eq]=" + encodeURIComponent(apiUser.email), {})
          .then((result) => {
            // we must find notifications for each customer, because endpoint does not know inactive users
            this.customers.forEach((customer) => {
              console.log("notifications customer", customer)
              let notificationsFound = false
              let isCustomerAdmin = false

              if (this.apiUser.privileges.some((privilege) => privilege.privilege === "IoTAdmin")) {
                isCustomerAdmin = true
              } else if (
                this.apiUser.privileges.some(
                  (privilege) => privilege.privilege === "CustomerAdmin" && privilege.customerId === customer.customerId
                )
              ) {
                isCustomerAdmin = true
              } else {
                isCustomerAdmin = false
              }

              result.data.data.forEach((notification) => {
                if (notification.customerId == customer.customerId) {
                  console.log("notifications result user", this.apiUser)
                  notifications.push({
                    customer: customer,
                    email: notification.email,
                    enabled: true,
                    language: notification.notifications[0].language,
                    isCustomerAdmin: isCustomerAdmin,
                    notifications: notification.notifications
                  })
                  notificationsFound = true
                }
              })

              if (!notificationsFound) {
                notifications.push({
                  customer: customer,
                  email: this.apiUser.email,
                  language: "CZ",
                  isCustomerAdmin: isCustomerAdmin,
                  enabled: false,
                  notifications: {}
                })
              }
            })
            this.notifications = notifications
            console.log("notifications result", this.notifications)
            this.loaded = true
            this.$store.commit("modals/setWaitingLoader", "")
          })
          .catch((error) => {
            if (error.status) {
              let err = []
              err.errors = []
              err.errors.push({
                message: error.status + " " + error.statusText
              })
              this.errorsToTranslate.push(err)
              if (this.errorsToTranslate.length > 0) {
                this.openedError = true
              }
            }
            this.$store.commit("modals/setWaitingLoader", "")
          })
      }
    },
    switchRadio() {
      this.radioDisabled = !this.radioDisabled
      this.configStore.isRadioHelpDisabled = this.radioDisabled
    },
    switchTutorial() {
      // This is the only user-facing "do I want the tutorial?" control, and the event
      // tutorial reuses the same modal, so the switch drives both.
      const show = this.tutorialVisible === false
      this.configStore.setShouldShowTutorial(show)
      this.configStore.setShouldShowEventTutorial(show)
      this.configStore.isTutorialVisible = show
      this.configStore.isEventTutorialVisible = show
      // "…Later" keys are presence flags — clear them, do not write "false".
      localStorage.removeItem("showTutorialLater")
      localStorage.removeItem("showEventTutorialLater")
    },
    switchTutorialAdmin() {
      const show = this.tutorialVisibleAdmin === false
      this.configStore.setShouldShowTutorialAdmin(show)
      this.configStore.isAdminTutorialVisible = show
      localStorage.removeItem("showTutorialLaterAdmin")
    },
    toggleEditNotificationsModal(box) {
      console.log("click", box)
      if (this.openedEditNotificationsModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditNotificationsModal = [])
          : this.openedEditNotificationsModal.splice(this.openedEditNotificationsModal.indexOf(box), 1)
      } else {
        this.openedEditNotificationsModal.push(box)
      }
    }
  }
}
</script>

<style scoped></style>
